import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';


class Meth extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="Methaphetamine" />
                <div className="container" style={{marginTop:"60px"}}>
                    <HashLink to='/faq#meth'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>

                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                        <img className="img-fluid" src="/assests/images/educationMethamphetamine.png" alt="methamphetamine">
                        </img>
                        
                        </div>
                    </div>
                    
                    <div className="content">
                        <h2>Methaphetamine</h2>
                        <p>Methamphetamine, or meth, also <b>highly addictive</b>, is a powerful stimulant which looks like <b>glass fragments or shiny white rocks</b>. It can be taken in various forms through snorting, smoking, or injecting. SInce the “high” achieved by the drug fades quickly, people use meth in repeated doses <b>(“binge and crash” cycle)</b>. It is more commonly referred to as meth, crank, crystal, ice, speed, blow, snow, and disco powder.</p>

                        <p>
                            It increases the amount of dopamine in the body, increasing movement and motivation. Since the drug floods the brain with dopamine and does not allow it from being recycled, it <b>reinforces drug-taking behaviours.</b>
                        </p>

                        <h4>
                            Short term effects include
                        </h4>
                        <ul style={{fontSize:"large"}}>
                            <li>Increased wakefulness, physical activity</li>
                            <li>Decreased appetite</li>
                            <li>Rapid breathing</li>
                            <li>Irregular or fast heartbeat</li>
                            <li>Increased BP, body temperature</li>
                        </ul>

                        <h4>
                            Long term effects include
                        </h4>
                        <ul style={{fontSize:"large"}}>
                            <li><b>Higher risk of HIV, hepatitis C</b>, other bloodborne diseases, skin or tissue infection, scarring or collapsed veins (in case of injecting)</li>
                            <li>Extreme weight loss</li>
                            <li>Severe dental problems (also called <b>“meth mouth”</b>)</li>
                            <li>Intense itching leading to <b>skin sores</b></li>
                            <li>Confusion, memory loss, anxiety</li>
                            <li>Disrupted sleep patterns</li>
                            <li>Aggressiveness, violent behaviour</li>
                            <li>Paranoia, hallucinations</li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default Meth;